import React from 'react';
import SvgIcon from './svgIcon';

const SvgEditOutline = props => {
  return (
    <SvgIcon width={24} height={24} {...props}>
      <g transform="translate(-1 -1)">
        <circle
          cx="10" cy="10" r="10"
          transform="translate(2 2)"
          style={{
            fill:'none', stroke:'currentColor', strokeLinecap:'round', strokeLinejoin:'round', strokeWidth:'2px'
          }}
        />
        <path
          transform="translate(12 12)"
          style={{
            fill:'none', stroke:'currentColor', strokeLinecap:'round', strokeLinejoin:'round', strokeWidth:'2px'
          }}
           d="M0 4V0"
        />
        <path
          transform="translate(12 8)"
          style={{
            fill:'none', stroke:'currentColor', strokeLinecap:'round', strokeLinejoin:'round', strokeWidth:'2px'
          }}
          d="M0 0h.01"
        />
      </g>
    </SvgIcon>
  );
};

export default SvgEditOutline;
